import { render, staticRenderFns } from "./InitiatingAssignment.vue?vue&type=template&id=f768197c"
import script from "./InitiatingAssignment.vue?vue&type=script&lang=js"
export * from "./InitiatingAssignment.vue?vue&type=script&lang=js"
import style0 from "./InitiatingAssignment.vue?vue&type=style&index=0&id=f768197c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports